import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendPaywallTouchEvent } from '~analytics/index';
import { PaywallScreens } from '~analytics/types';

export type AiFeatureType = 'generate' | 'copypaste' | 'extract';
export type QuotaLimitType = 'soft' | 'hard';

export interface AiQuotaPaywallEventAdapterParams {
  featureType: AiFeatureType;
  limitType: QuotaLimitType;
}

const PAYWALL_SCREEN_MAP: Record<
  AiFeatureType,
  Record<QuotaLimitType, PaywallScreens>
> = {
  generate: {
    soft: PaywallScreens.QuizEditGenerateQuestionsSoftLimit,
    hard: PaywallScreens.QuizEditGenerateQuestionsHardLimit,
  },
  copypaste: {
    soft: PaywallScreens.QuizEditCopyPasteQuestionsSoftLimit,
    hard: PaywallScreens.QuizEditCopyPasteQuestionsHardLimit,
  },
  extract: {
    soft: PaywallScreens.QuizEditExtractQuestionsSoftLimit,
    hard: PaywallScreens.QuizEditExtractQuestionsHardLimit,
  },
};

const _sentPaywallScreens = new Set<PaywallScreens>();

export class AiQuotaPaywallEventAdapter extends EventAdapter {
  protected intercomEventKey = 'paywall-touch';
  protected amplitudeEventFunction = sendPaywallTouchEvent;
  private paywallScreen: PaywallScreens;

  constructor({ featureType, limitType }: AiQuotaPaywallEventAdapterParams) {
    super();

    this.paywallScreen = PAYWALL_SCREEN_MAP[featureType][limitType];

    this.eventData = {
      feature_name: this.paywallScreen,
      secondary_feature: null,
    };
  }

  public sendAnalytics() {
    if (_sentPaywallScreens.has(this.paywallScreen)) {
      return;
    }
    _sentPaywallScreens.add(this.paywallScreen);
    super.sendAnalytics();
  }
}
